<template>
  <div>
    <b-row class='mt-2'>
      <b-col>
        <h4 v-if='item && item.type'>{{item.type.toUpperCase()}}</h4>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-button
          variant='outline-primary'
          @click='() => actions.handleAddMapMarker(flatPage.id, item.id)'
        >
          Dodaj lokalizacje
        </b-button>
      </b-col>          
    </b-row>
    <div v-for='(marker, i) in item.value.markers' :key='i' class='mt-3'>
      <b-row>
        <b-col>
          <b-button variant="danger" size='sm' class='float-right' @click='() => actions.handleRemoveMapMarker(flatPage.id, item.id, marker.id)'><b-icon-trash /></b-button>
        </b-col>
      </b-row>  
      <b-row>
        <b-col>
          <label>Opis</label>
          <b-form-input
            :value='marker.description'
            @input='(e) => actions.handleMapMarkerChanged(flatPage.id, item.id, marker.id, "description", e)'
          />
        </b-col>
      </b-row>
      <b-row class='mt-2 mb-1'>
        <b-col>
          <label>Latitude</label>
          <b-form-input
            :value='marker.latitude'
            @input='(e) => actions.handleMapMarkerChanged(flatPage.id, item.id, marker.id, "latitude", e)'
          />
        </b-col>
        <b-col>
          <label>Longitude</label>
          <b-form-input
            :value='marker.longitude'
            @input='(e) => actions.handleMapMarkerChanged(flatPage.id, item.id, marker.id, "longitude", e)'
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <hr />
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>

  import { LOCALES } from '@/utils';
  import { BIconTrash } from 'bootstrap-vue'  
 
  import {
    handleAddMapMarker,
    handleMapMarkerChanged,
    handleRemoveMapMarker,
  } from '@/store/utils.js'
  
  export default {
    props: ['flatPage', 'item'],
    components: { BIconTrash },
    computed: {
    },
    data() {
      return {
        actions: {
          handleAddMapMarker,
          handleMapMarkerChanged,
          handleRemoveMapMarker,
        },
        locales: LOCALES,
      }
    },
  }
</script>
